(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["palmy-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palmy-buy-now')) {
    customElements.define('palmy-buy-now', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const form = this.closest('form');
        const nativeButton = form?.querySelector('[data-atc-form]');
        if (!form || !nativeButton || nativeButton.hasAttribute('disabled')) return;
        this.initialized = true;
        this.hidden = false;
        const root = window.Shopify?.routes?.root || '/';
        const button = this.querySelector('button');
        const label = button.querySelector('[data-palmy-buy-label]');
        const totalLabel = button.querySelector('[data-palmy-buy-total]');
        const initialLabel = label.textContent;
        const error = this.querySelector('[role=alert]');
        const status = this.querySelector('[role=status]');
        const quantity = () => Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
        const kwd = fils => new Intl.NumberFormat('en-US', { minimumFractionDigits:3, maximumFractionDigits:3 }).format(fils / 1000) + ' KWD';
        const sync = () => { button.disabled = this.pending || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true'; };
        const renderTotal = () => {
          const state = window.palmyState;
          if (!state || !form.closest('.t4s-section-main-product')) { totalLabel.textContent = ''; return; }
          const percent = window.palmyOffer?.applied ? window.palmyOffer.percent : 0;
          totalLabel.textContent = kwd(Math.round(state.price * quantity() * 10 * (100 - percent) / 100));
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(nativeButton, { attributes:true, attributeFilter:['disabled','aria-disabled'] });
        sync();
        document.addEventListener('palmy:variant', renderTotal);
        document.addEventListener('palmy:offer', renderTotal);
        form.addEventListener('change', renderTotal);
        form.addEventListener('input', renderTotal);
        renderTotal();
        form.addEventListener('click', event => { if(this.pending){event.preventDefault();event.stopImmediatePropagation();} }, true);
        form.addEventListener('submit', event => { if(this.pending){event.preventDefault();event.stopImmediatePropagation();} }, true);
        const ready = () => {
          error.hidden = true;
          form.palmyFitUpdate?.();
          if(form.palmyFitValidate && !form.palmyFitValidate()) return false;
          if(!form.reportValidity()) return false;
          sync();
          if(button.disabled) return false;
          if(!new FormData(form).get('id')) { error.textContent = this.dataset.unavailable; error.hidden = false; return false; }
          return true;
        };
        const addToCart = async () => {
          const response = await fetch(root + 'cart/add.js', { method:'POST', body:new FormData(form), headers:{Accept:'application/json'} });
          const data = await response.json();
          if(!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
        };
        const run = async () => {
          this.pending = true;
          button.setAttribute('aria-busy','true');
          label.textContent = this.dataset.loading;
          status.textContent = this.dataset.loading;
          sync();
          try {
            await addToCart();
            const offer = window.palmyOffer;
            const code = offer?.applied ? offer.code : '';
            window.location.assign(root + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''));
          } catch(problem) {
            error.textContent = problem instanceof TypeError ? this.dataset.error : problem.message || this.dataset.error;
            error.hidden = false;
            this.pending = false;
            button.removeAttribute('aria-busy');
            label.textContent = initialLabel;
            status.textContent = '';
            sync();
          }
        };
        button.addEventListener('click', () => { if(!this.pending && ready()) run(); });
        window.addEventListener('pageshow', () => { this.pending = false; button.removeAttribute('aria-busy'); label.textContent = initialLabel; status.textContent = ''; sync(); renderTotal(); });
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palmy-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palmy-offer')) {
    const offer = window.palmyOffer = window.palmyOffer || { code:'', percent:0, applied:null, pending:null };
    const readCode = () => {
      const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      return match ? decodeURIComponent(match[1]).trim() : '';
    };
    const kwd = fils => new Intl.NumberFormat('en-US', { minimumFractionDigits:3, maximumFractionDigits:3 }).format(fils / 1000) + ' KWD';
    const pad = value => String(value).padStart(2, '0');
    const countdown = ms => { const seconds = Math.max(0, Math.floor(ms / 1000)); return pad(Math.floor(seconds / 3600)) + ':' + pad(Math.floor(seconds % 3600 / 60)) + ':' + pad(seconds % 60); };
    const removeCode = async () => {
      const code = offer.code.toUpperCase();
      if (readCode().toUpperCase() === code) {
        const host = location.hostname.replace(/^www\./, '');
        ['', '; domain=' + location.hostname, '; domain=.' + host].forEach(domain => { document.cookie = 'discount_code=; Max-Age=0; path=/' + domain; });
      }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const cart = await (await fetch(root + 'cart.js', { credentials:'same-origin' })).json();
        const codes = (cart.discount_codes || []).map(discount => discount.code);
        if (codes.some(current => current.toUpperCase() === code)) {
          await fetch(root + 'cart/update.js', { method:'POST', credentials:'same-origin', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ discount:codes.filter(current => current.toUpperCase() !== code).join(',') }) });
        }
      } catch (error) {}
    };
    const end = () => {
      clearInterval(offer.timer);
      offer.ended = true;
      offer.applied = false;
      document.documentElement.classList.add('palmy-offer-ended');
      document.querySelectorAll('palmy-offer').forEach(element => { element.hidden = true; element.removeAttribute('data-applied'); });
      document.querySelectorAll('[data-offer-timer-label]').forEach(element => { element.hidden = true; });
      removeCode();
      document.dispatchEvent(new CustomEvent('palmy:offer', { detail:offer }));
    };
    const tick = () => {
      const left = offer.endsAt - Date.now();
      if (left <= 0) return end();
      const text = countdown(left);
      document.querySelectorAll('[data-offer-timer]').forEach(element => { element.textContent = text; });
      document.querySelectorAll('[data-offer-timer-label][hidden]').forEach(element => { element.hidden = false; });
    };
    const broadcast = () => {
      document.querySelectorAll('palmy-offer').forEach(element => element.render?.());
      document.dispatchEvent(new CustomEvent('palmy:offer', { detail:offer }));
    };
    const apply = async force => {
      if (offer.ended) return false;
      const current = readCode();
      if (current && current.toUpperCase() === offer.code.toUpperCase()) { offer.applied = true; broadcast(); return true; }
      if (current && !force) { offer.applied = false; broadcast(); return false; }
      try {
        const root = window.Shopify?.routes?.root || '/';
        await fetch(root + 'discount/' + encodeURIComponent(offer.code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials:'same-origin' });
      } catch (error) {}
      offer.applied = !offer.ended && readCode().toUpperCase() === offer.code.toUpperCase();
      broadcast();
      return offer.applied;
    };
    offer.apply = apply;
    customElements.define('palmy-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        offer.code = offer.code || this.dataset.code;
        offer.percent = offer.percent || Number(this.dataset.percent) || 0;
        const hours = Number(this.dataset.window);
        if (hours && !offer.endsAt && !offer.ended) {
          let start = 0;
          try {
            const key = 'palmy-offer-' + offer.code.toLowerCase();
            start = Number(localStorage.getItem(key));
            if (!start) { start = Date.now(); localStorage.setItem(key, String(start)); }
          } catch (error) { start = 0; }
          if (start) {
            offer.endsAt = start + hours * 36e5;
            tick();
            if (!offer.ended) offer.timer = setInterval(tick, 1000);
          }
        }
        if (offer.ended) { this.hidden = true; return; }
        this.button = this.querySelector('[data-offer-copy]');
        this.button.addEventListener('click', () => this.activate());
        this.price = this.querySelector('[data-offer-price]');
        if (this.price) {
          const update = () => { const state = window.palmyState; if (state) this.price.textContent = kwd(Math.round(state.price * 10 * (100 - offer.percent) / 100)); };
          document.addEventListener('palmy:variant', update);
          update();
        }
        if (this.dataset.auto === 'true') { if (!offer.pending) offer.pending = apply(false); }
        else if (offer.applied === null) offer.applied = false;
        this.render();
      }
      render() {
        if (offer.applied === null) return;
        this.toggleAttribute('data-applied', offer.applied);
        if (this.dataset.state === 'copied' || this.dataset.state === 'manual') return;
        const action = this.querySelector('[data-offer-action]');
        const title = this.querySelector('[data-offer-title]');
        const hint = this.querySelector('[data-offer-hint]');
        action.textContent = offer.applied ? this.dataset.appliedLabel : this.dataset.copy;
        title.textContent = offer.applied && this.classList.contains('palmy-offer--bar') ? this.dataset.appliedTitle : this.dataset.title;
        hint.textContent = offer.applied ? this.dataset.appliedHint : this.dataset.hint;
      }
      async activate() {
        if (this.busy) return;
        this.busy = true;
        if (!offer.applied) await apply(true);
        await this.copy();
        this.busy = false;
      }
      async copy() {
        let copied = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(offer.code);
            copied = true;
          }
        } catch (error) {}
        if (!copied) {
          const input = document.createElement('textarea');
          input.value = offer.code;
          input.setAttribute('readonly', '');
          input.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px;';
          document.body.appendChild(input);
          input.select();
          try { copied = document.execCommand('copy'); } catch (error) {}
          input.remove();
          this.button.focus({ preventScroll:true });
        }
        if (copied) {
          document.querySelectorAll('palmy-offer').forEach(element => {
            element.dataset.state = 'copied';
            element.querySelector('[data-offer-action]').textContent = element.dataset.copied;
            element.querySelector('[data-offer-hint]').textContent = element.dataset.success;
          });
          this.querySelector('[data-offer-status]').textContent = offer.applied ? this.dataset.appliedHint : this.dataset.success;
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => document.querySelectorAll('palmy-offer').forEach(element => { delete element.dataset.state; element.render(); }), 2200);
        } else if (!offer.applied) {
          this.dataset.state = 'manual';
          this.querySelector('[data-offer-action]').textContent = this.dataset.manual;
          this.querySelector('[data-offer-hint]').textContent = this.dataset.fallback;
          this.querySelector('[data-offer-status]').textContent = this.dataset.fallback;
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('[data-offer-code]'));
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        } else {
          this.querySelector('[data-offer-status]').textContent = this.dataset.appliedHint;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palmy-size-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palmy-size-finder')) {
    /* Tuning. All measurements in inches unless named otherwise. */
    const STORE = 'palmy-fit';
    const AREAS = ['bust', 'waist', 'hip'];
    const EASE = 0;                                       // 0 = the chart lists body measurements; use 2 if it lists finished-garment measurements
    const TOLERANCE = { bust:.5, waist:1, hip:1 };       // how far a body may exceed a size and still fit comfortably
    const FIT = { close:1, regular:0, loose:-1 };         // closer fit allows 1 in more, roomier keeps 1 in spare
    const SHAPE = { bust:1.5, waist:2, hip:2 };           // added where the shopper says she is fuller
    const LENGTH = { dress:{ full:.85, ankle:-3 }, bottom:{ full:.62, ankle:-3 }, top:{ hip:.40, long:.47 } }; // share of height, or inches off "full"
    const ALIAS = { XSMALL:'XS', SMALL:'S', MEDIUM:'M', MEDUIM:'M', LARGE:'L', XLARGE:'XL', XXLARGE:'XXL' };
    const estimate = (height, weight, shape) => {
      const bmi = weight / (height / 100) ** 2;
      const scale = Math.sqrt(height / 163) / 2.54;
      return {
        bust:(1.9 * bmi + 46) * scale + (shape.includes('bust') ? SHAPE.bust : 0),
        waist:(2.2 * bmi + 22) * scale + (shape.includes('waist') ? SHAPE.waist : 0),
        hip:(2 * bmi + 53) * scale + (shape.includes('hip') ? SHAPE.hip : 0),
      };
    };
    const read = () => { try { return JSON.parse(localStorage.getItem(STORE)) || null; } catch (error) { return null; } };
    const write = value => { try { localStorage.setItem(STORE, JSON.stringify(value)); } catch (error) {} };
    const fill = (text, values) => text.replace(/\[(\w+)\]/g, (match, key) => values?.[key] ?? match);
    const nameOf = value => { const key = String(value || '').trim().toUpperCase(); return ALIAS[key] || key; };
    const calm = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    customElements.define('palmy-size-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.form = this.closest('form');
        this.box = this.closest('[data-swatch-option]');
        if (!this.form || !this.box) return;
        this.ready = true;
        this.text = JSON.parse(this.querySelector('[data-finder-text]').textContent);
        this.chart = this.dataset.chart.split('|').map(row => { const [name, bust, waist, hip] = row.split(':'); return { name, bust:+bust, waist:+waist, hip:+hip }; });
        this.chips = new Map();
        this.box.querySelectorAll('[data-swatch-item][data-value]').forEach(chip => {
          const name = nameOf(chip.dataset.value);
          if (/^(CUSTOM|SPECIAL)$/.test(name)) this.customChip = chip;
          else if (this.chart.some(size => size.name === name)) this.chips.set(name, chip);
        });
        this.sizes = this.chart.filter(size => this.chips.has(size.name));
        if (!this.sizes.length) return;
        this.inStock = null;
        try {
          const variants = JSON.parse(this.form.querySelector('[data-palmy-variants]').textContent);
          const index = JSON.parse(this.form.querySelector('[data-palmy-options]').textContent).findIndex(name => /size/i.test(name));
          if (index >= 0) this.inStock = new Set(variants.filter(variant => variant.available).map(variant => nameOf(variant.options[index])));
        } catch (error) {}
        this.soldout = name => this.inStock ? !this.inStock.has(name) : /is--(soldout|unavailable)/.test(this.chips.get(name).className);
        this.fields = [...this.form.querySelectorAll('[data-palmy-length-field] select')].map(select => {
          const title = select.closest('[data-palmy-length-field]').querySelector('label')?.textContent || select.name;
          const label = /skirt/i.test(title) ? 'skirt' : /pant|trouser/i.test(title) ? 'pants' : /top/i.test(title) ? 'top' : /jacket|blazer/i.test(title) ? '' : 'dress';
          const kind = label === 'skirt' || label === 'pants' ? 'bottom' : label;
          const options = [...select.options].map(option => Number(option.value)).filter(Boolean);
          return { select, label, kind, options };
        }).filter(field => field.kind && field.options.length);
        const saved = read() || {};
        this.state = { step:1, height:saved.height || 160, weight:saved.weight || 0, fit:saved.fit || 'regular', shape:saved.shape || [], lengths:saved.lengths || {}, view:'', applied:false };
        this.q = selector => this.querySelector(selector);
        this.card = this.q('[data-finder-card]');
        this.openButton = this.q('[data-finder-open]');
        this.savedBar = this.q('[data-finder-saved]');
        this.inputs = { height:this.q('[data-finder-input="height"]'), weight:this.q('[data-finder-input="weight"]') };
        this.numbers = { height:this.q('[data-finder-number="height"]'), weight:this.q('[data-finder-number="weight"]') };
        this.inputs.height.value = this.state.height;
        if (this.state.weight) this.inputs.weight.value = this.state.weight;
        const clamp = (key, value) => Math.min(Number(this.inputs[key].max), Math.max(Number(this.inputs[key].min), value));
        const set = (key, value) => { this.state[key] = value; this.inputs[key].value = value; this.state.view = ''; };

        this.addEventListener('input', event => {
          const range = event.target.dataset.finderInput, number = event.target.dataset.finderNumber;
          if (range) set(range, Number(event.target.value));
          else if (number) {
            const value = parseInt(event.target.value, 10);
            if (!(value >= Number(this.inputs[number].min) && value <= Number(this.inputs[number].max))) return;
            set(number, value);
          } else return;
          this.render();
        });
        this.addEventListener('change', event => {
          const number = event.target.dataset.finderNumber;
          if (!number) return;
          const value = parseInt(event.target.value, 10);
          if (!Number.isNaN(value)) set(number, clamp(number, value));
          event.target.blur();
          this.render();
        });
        this.addEventListener('focusin', event => { if (event.target.dataset.finderNumber) event.target.select(); });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.closest('[data-finder-fit]')) {
            this.state.fit = button.dataset.value;
            this.state.view = '';
          } else if (button.closest('[data-finder-shape]')) {
            const value = button.dataset.value;
            this.state.shape = this.state.shape.includes(value) ? this.state.shape.filter(item => item !== value) : [...this.state.shape, value];
            this.state.view = '';
          } else if (button.dataset.finderSize) {
            this.state.view = button.dataset.finderSize;
          } else if (button.dataset.finderLength) {
            const [kind, choice] = button.dataset.finderLength.split(':');
            this.state.lengths = { ...this.state.lengths, [kind]:choice };
          } else if (button.matches('[data-finder-next]')) {
            this.go(2);
            return;
          } else if (button.matches('[data-finder-back]')) {
            this.go(1);
            return;
          } else if (button.matches('[data-finder-open],[data-finder-edit]')) {
            this.toggle(true);
            return;
          } else if (button.matches('[data-finder-close]')) {
            this.toggle(false);
            return;
          } else if (button.matches('[data-finder-apply],[data-finder-use]')) {
            this.apply();
            return;
          } else return;
          this.render();
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.card.hidden) { event.preventDefault(); this.toggle(false); }
          if (event.key === 'Enter' && event.target.dataset.finderNumber) { event.preventDefault(); event.target.blur(); }
        });
        this.hidden = false;
        this.render();
      }

      /* Text in the page language followed by the other language. */
      pair(element, key, values) {
        const other = document.createElement('span');
        other.className = 'palmy-finder__alt';
        other.lang = this.dataset.altLang;
        other.dir = this.dataset.altDir;
        const pick = source => key.split('.').reduce((value, part) => value?.[part], source);
        other.textContent = fill(pick(this.text.alt), values);
        element.replaceChildren(fill(pick(this.text.main), values), other);
      }

      /* Smallest size whose limits the estimated body stays within, for each area and overall. */
      result() {
        const { height, weight, fit, shape } = this.state;
        if (!weight) return null;
        const body = estimate(height, weight, shape);
        const fits = (size, area, extra) => body[area] + EASE <= size[area] + TOLERANCE[area] + extra;
        const best = this.sizes.find(size => AREAS.every(area => fits(size, area, FIT[fit])));
        const beyond = !this.chart.some(size => AREAS.every(area => fits(size, area, FIT[fit])));
        const levels = size => Object.fromEntries(AREAS.map(area => {
          const slack = size[area] - body[area] - EASE;
          const level = slack < -TOLERANCE[area] - 1 ? 0 : slack < -TOLERANCE[area] ? 1 : slack < 1 ? 2 : slack < 3 ? 3 : 4;
          return [area, level];
        }));
        return { best:beyond ? null : best, beyond:beyond || !best, levels };
      }

      lengthChoices(field) {
        const inches = this.state.height / 2.54;
        const nearest = value => field.options.reduce((a, b) => Math.abs(b - value) < Math.abs(a - value) ? b : a);
        const rule = LENGTH[field.kind];
        const list = field.kind === 'top'
          ? [['hip', nearest(rule.hip * inches)], ['long', nearest(rule.long * inches)]]
          : [['full', nearest(rule.full * inches)], ['ankle', nearest(Math.round(rule.full * inches) + rule.ankle)]];
        return list.filter(([, value], index) => index === 0 || value !== list[0][1]);
      }

      render() {
        const { state, text } = this;
        const result = this.result();
        if (!result) state.step = 1;
        ['height', 'weight'].forEach(key => {
          const input = this.inputs[key], number = this.numbers[key];
          if (document.activeElement !== number) number.value = state[key] || '';
          input.style.setProperty('--fill', (Number(input.value) - Number(input.min)) / (Number(input.max) - Number(input.min)) * 100 + '%');
        });
        const next = this.q('[data-finder-next]');
        next.disabled = !result;
        this.pair(next, result ? 'next' : 'nextEmpty');
        this.q('[data-finder-panel="1"]').hidden = state.step !== 1;
        this.q('[data-finder-panel="2"]').hidden = state.step !== 2;
        this.q('[data-finder-back]').hidden = state.step !== 2;
        this.q('[data-finder-progress]').style.width = state.step === 2 ? '100%' : '50%';
        this.querySelectorAll('[data-finder-fit] button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === state.fit)));
        this.querySelectorAll('[data-finder-shape] button').forEach(button => button.setAttribute('aria-pressed', String(state.shape.includes(button.dataset.value))));
        const apply = this.q('[data-finder-apply]');
        this.q('[data-finder-match]').hidden = !result?.best;
        this.q('[data-finder-custom]').hidden = !result?.beyond;
        this.q('[data-finder-detail]').hidden = !result?.best;
        this.q('[data-finder-fine]').hidden = !result?.best;
        this.chips.forEach(chip => chip.classList.remove('is-your-size'));
        this.target = '';
        if (result?.best) {
          const best = result.best.name;
          const view = this.sizes.find(size => size.name === state.view) || result.best;
          const levels = result.levels(view);
          this.target = view.name;
          this.chips.get(best).classList.add('is-your-size');
          this.pair(this.q('[data-finder-size-label]'), view.name === best ? 'yourSize' : 'size');
          const badge = this.q('[data-finder-size]');
          if (badge.textContent !== view.name) {
            badge.textContent = view.name;
            badge.classList.remove('is-pop');
            void badge.offsetWidth;
            badge.classList.add('is-pop');
          }
          if (view.name === best) this.pair(this.q('[data-finder-sub]'), 'subBest', { height:state.height, weight:state.weight });
          else this.pair(this.q('[data-finder-sub]'), 'feel.' + Math.min(...AREAS.map(area => levels[area])));
          AREAS.forEach(area => {
            this.q('[data-finder-tile="' + area + '"]').dataset.level = levels[area];
            this.pair(this.q('[data-finder-feel="' + area + '"]'), 'feel.' + levels[area]);
          });
          this.q('[data-finder-compare]').replaceChildren(...this.sizes.map(size => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = size.name;
            button.dataset.finderSize = size.name;
            button.setAttribute('aria-pressed', String(size.name === view.name));
            if (size.name === best) button.dataset.best = '';
            if (this.soldout(size.name)) button.dataset.soldout = '';
            return button;
          }));
          const warning = this.q('[data-finder-soldout]');
          warning.hidden = !this.soldout(view.name);
          if (!warning.hidden) this.pair(warning, 'soldout', { size:view.name });
          apply.disabled = this.soldout(view.name);
          this.pair(apply, 'apply', { size:view.name });
        } else if (result?.beyond) {
          apply.disabled = !this.customChip;
          this.pair(apply, 'applyCustom');
        }
        const lengths = this.q('[data-finder-lengths]');
        lengths.hidden = !result || result.beyond || !this.fields.length;
        if (!lengths.hidden) {
          this.q('[data-finder-lengths-list]').replaceChildren(...this.fields.map(field => {
            const row = document.createElement('div');
            row.className = 'palmy-finder__length';
            const group = document.createElement('div');
            const choices = this.lengthChoices(field);
            const chosen = state.lengths[field.kind] && choices.some(([id]) => id === state.lengths[field.kind]) ? state.lengths[field.kind] : (field.kind === 'top' ? '' : choices[0][0]);
            field.pick = chosen ? choices.find(([id]) => id === chosen)[1] : 0;
            choices.forEach(([id, value]) => {
              const button = document.createElement('button');
              button.type = 'button';
              button.dataset.finderLength = field.kind + ':' + id;
              button.setAttribute('aria-pressed', String(id === chosen));
              const inches = document.createElement('b');
              inches.dir = 'ltr';
              inches.textContent = value + '″';
              const label = document.createElement('span');
              this.pair(label, 'length.' + id);
              label.style.display = 'contents';
              button.append(inches, label);
              group.append(button);
            });
            if (this.fields.length > 1) {
              const title = document.createElement('span');
              this.pair(title, 'kind.' + field.label);
              row.append(title);
            }
            row.append(group);
            return row;
          }));
        }
        const closed = this.card.hidden;
        this.savedBar.hidden = !closed || !result?.best;
        this.openButton.hidden = !closed || !!result?.best;
        if (!this.savedBar.hidden) {
          this.q('[data-finder-saved-size]').textContent = state.applied ? this.picked : result.best.name;
          this.pair(this.q('[data-finder-saved-title]'), state.applied ? 'picked' : 'saved');
          this.q('[data-finder-saved-meta]').textContent = state.height + ' ' + text.cm + ' · ' + state.weight + ' ' + text.kg;
          this.q('[data-finder-use]').hidden = state.applied || this.soldout(result.best.name);
        }
      }

      go(step) {
        this.state.step = step;
        this.state.view = '';
        if (step === 1) this.q('[data-finder-more]').open = false;
        this.render();
        this.scrollIntoView({ behavior:calm(), block:'start' });
      }

      toggle(open) {
        this.card.hidden = !open;
        this.openButton.setAttribute('aria-expanded', String(open));
        document.body.classList.toggle('palmy-finder-open', open);
        if (open) {
          this.state.applied = false;
          this.state.step = this.state.weight ? 2 : 1;
          this.q('[data-finder-more]').open = false;
        }
        this.render();
        if (open) this.scrollIntoView({ behavior:calm(), block:'start' });
        else (this.savedBar.hidden ? this.openButton : this.q('[data-finder-edit]')).focus({ preventScroll:true });
      }

      apply() {
        const result = this.result();
        if (!result) return;
        const { state, text } = this;
        const shut = () => {
          this.card.hidden = true;
          this.openButton.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('palmy-finder-open');
        };
        if (result.beyond) {
          if (!this.customChip) return;
          this.customChip.click();
          shut();
          this.render();
          return;
        }
        const name = this.card.hidden ? result.best.name : this.target || result.best.name;
        this.render();
        this.chips.get(name).click();
        this.fields.forEach(field => {
          if (!field.pick) return;
          field.select.value = String(field.pick);
          field.select.removeAttribute('aria-invalid');
          field.select.dispatchEvent(new Event('change', { bubbles:true }));
        });
        const note = this.q('[data-finder-note]');
        note.disabled = false;
        note.value = [state.height + ' cm', state.weight + ' kg', text.main.fit[state.fit], state.shape.length ? 'fuller: ' + state.shape.join('/') : '', 'suggested ' + result.best.name + (name !== result.best.name ? ', chose ' + name : '')].filter(Boolean).join(' · ');
        write({ height:state.height, weight:state.weight, fit:state.fit, shape:state.shape, lengths:state.lengths });
        this.picked = name;
        state.applied = true;
        state.view = '';
        shut();
        this.render();
        this.box.scrollIntoView({ behavior:calm(), block:'nearest' });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palmy-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palmy-size-guide')) {
    customElements.define('palmy-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.trigger = document.querySelector('[data-palmy-guide-toggle][aria-controls="' + CSS.escape(this.id) + '"]');
        if (!this.trigger) return;
        this.ready = true;
        this.trigger.hidden = false;
        const showSize = size => {
          this.querySelectorAll('[data-guide-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideSize === size)));
          this.querySelectorAll('[data-guide-measurements]').forEach(panel => { panel.hidden = panel.dataset.guideMeasurements !== size; });
        };
        const close = () => { this.hidden = true; this.trigger.setAttribute('aria-expanded','false'); this.trigger.focus({preventScroll:true}); };
        this.trigger.addEventListener('click', () => {
          if (!this.hidden) { close(); return; }
          const selected = this.trigger.closest('[data-swatch-option]')?.querySelector('[data-current-value]')?.textContent.trim().toUpperCase();
          const aliases = {XSMALL:'XS',SMALL:'S',MEDIUM:'M',MEDUIM:'M',LARGE:'L',XLARGE:'XL',XXLARGE:'XXL'};
          const size = aliases[selected] || selected;
          showSize(['XS','S','M','L','XL','XXL'].includes(size) ? size : 'XS');
          this.hidden = false;
          this.trigger.setAttribute('aria-expanded','true');
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-guide-size]');
          if (button) showSize(button.dataset.guideSize);
          if (event.target.closest('[data-guide-close]')) close();
        });
        this.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
